/**
 * Shared worker utility functions.
 * Eliminates duplicated worker ID parsing patterns across the codebase.
 */

/**
 * Extract the desk index from a worker ID string.
 * Handles both short ("worker-0") and full ("dev-user-worker-1") formats.
 * @returns The desk index (0-3), or null if the workerId doesn't match.
 */
export function extractDeskIndex(workerId: string): number | null {
  const match = workerId.match(/worker-(\d+)$/);
  return match ? parseInt(match[1], 10) : null;
}
